import { Project } from '../types/Project';

type GetProjectProps = {
  baseUrl: string;
  token: string;
  projectId: string;
};

export async function getProject({
  baseUrl,
  token,
  projectId,
}: GetProjectProps): Promise<Project> {
  if (!baseUrl || !token || !projectId) {
    throw new Error('Proxy base URL or projectId not available');
  }

  const projectUrl = new URL(`${baseUrl}/projects`);
  projectUrl.search = new URLSearchParams({
    projectId,
  }).toString();

  const response = await fetch(projectUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    // Error response: ex if project not found then mark is archived.
    return { id: projectId, archived: true };
  }
  const project = await response.json();
  return { id: project?.id, archived: !!project?.archived };
}
